export default "__VITE_ASSET__DrtOGC_Z__"